/* Product-link sharing with native-share, clipboard, and legacy fallbacks.
   The original control did nothing in desktop browsers without navigator.share. */
(function () {
  'use strict';

  function setState(button, label) {
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.classList.add('is-feedback');
    window.setTimeout(function () {
      button.setAttribute('aria-label', 'Share or copy this product link');
      button.setAttribute('title', 'Share or copy');
      button.classList.remove('is-feedback');
    }, 2200);
  }

  function legacyCopy(value) {
    var area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(area);
    area.select();
    var worked = false;
    try { worked = document.execCommand('copy'); } catch (e) { worked = false; }
    document.body.removeChild(area);
    return worked;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ctx-product-share]');
    if (!button) return;
    event.preventDefault();

    var url = window.location.href;
    var title = button.dataset.ctxShareTitle || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).then(function () {
        setState(button, 'Link shared');
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { setState(button, 'Link copied'); });
        } else if (legacyCopy(url)) { setState(button, 'Link copied'); }
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        setState(button, 'Link copied');
      }).catch(function () {
        if (legacyCopy(url)) setState(button, 'Link copied');
      });
    } else if (legacyCopy(url)) {
      setState(button, 'Link copied');
    }
  });
}());
